import { RestaurantsHeader } from "./components/RestaurantsHeader"
import { DiningLocations } from "./components/DiningLocations"

export function Restaurants({ restaurantsHead, diningLocations }) {
    return (
        <>
            {restaurantsHead && <RestaurantsHeader {...restaurantsHead} />}
            <DiningLocations diningLocations={diningLocations} />
        </>
    )
}
